module.exports = __webpack_public_path__ + "azure.e5b089.svg";